<template>
	<div class="GYLFW">
		<div class="p30" style="padding-bottom: 6px;">
			<el-row :gutter="30">
				<template v-for="(item, i) in items">
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
						<div class="item tran3" @click="look(item)">
							<div class="img mb20">
								<el-image style="width: 100%; height: 220px" :src="item.img" :fit="'cover'"></el-image>
							</div>
							<div class="info">
								<div class="c3 f16 hang1 tt b bred tz">{{item.title}}</div>
							</div>
						</div>
					</el-col>
				</template>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				items: [],
			}
		},
		created() {
			this.items = this.$store.state.GYLFW;
			this.items.forEach((x,i) => {
				x.img = require(`@/assets/GYLFW_${i+1}.jpg`)
			})
		},
		mounted() {

		},
		methods: {
			look(item) {
				this.$emit('look', item)
			}
		}
	}
</script>

<style lang="scss">
	.GYLFW {
		
	}
</style>
